<template>
   <div class="device-container">
      <div class="flex-row">
         <div>查询日期&nbsp;&nbsp;&nbsp;</div>
         <el-date-picker type="date" placeholder="请选择日期" v-model="queryForm.queryDate"
            @change="queryHeartbeat"></el-date-picker>
      </div>
      <el-row>
         <el-col v-for="(item, index) in onlineTimes" :key="index" :offset="item.offset" :span="item.span">
            <el-popover :visible-arrow="false" :offset="10" trigger="hover">
               <template slot="reference">
                  <div class="device-online"></div>
               </template>
               <template>
                  <img class="device-status" src="https://swapp-image.gxapp.iydsj.com/admin-api/status_on.png" alt="">
                  <div class="device-state">{{ handleState(onlineTimes, index) }}</div>
               </template>
            </el-popover>
         </el-col>
      </el-row>
      <el-row>
         <el-col v-for="(item, index) in offlineTimes" :key="index" :offset="item.offset" :span="item.span">
            <el-popover :visible-arrow="false" :offset="10" trigger="hover">
               <template slot="reference">
                  <div class="device-offline"></div>
               </template>
               <template>
                  <img class="device-status" src="https://swapp-image.gxapp.iydsj.com/admin-api/status_off.png" alt="">
                  <div class="device-state">{{ handleState(offlineTimes, index) }}</div>
               </template>
            </el-popover>
         </el-col>
      </el-row>
      <el-row>
         <el-col v-for="(item, index) in timeSpans" :span="1">
            <div class="device-time">{{ item + '时' }}</div>
         </el-col>
      </el-row>
   </div>
</template>

<script>
export default {
   props: ['uid'],
   data() {
      return {
         queryForm: {
            queryDate: new Date(),
         },
         timeSpans: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
         onlineTimes: [],
         offlineTimes: []
      }
   },
   watch: {
      uid: function (val) {
         this.queryHeartbeat();
      },
   },
   methods: {
      // 查询设备心跳状态列表
      queryHeartbeat() {
         let params = {
            uid: this.uid,
            queryDate: this.$util.dateFormat(this.queryForm.queryDate, 'yyyy-MM-dd')
         }
         this.$http({
            method: 'get',
            url: this.$util.aioIP + '/api/m/hw/onePc/v210/heartbeat/list',
            params: params,
         }).then((result) => {
            this.onlineTimes = []
            this.offlineTimes = []
            if (result.body.data) {
               this.handleTimeSpan(result.body.data)
            }
         }).catch(() => {
            this.onlineTimes = []
            this.offlineTimes = []
         })
      },

      // 处理时间段
      handleTimeSpan(data) {
         let timeSpanList = this.timeSpans
         let queryDay = this.$util.dateFormat(this.queryForm.queryDate, 'yyyy-MM-dd')
         let currentDay = this.$util.dateFormat(new Date(), 'yyyy-MM-dd')

         if (queryDay === currentDay) {
            let hour = new Date().getHours()
            timeSpanList = this.timeSpans.filter((item) => {
               return item <= hour
            })
         } else if (queryDay > currentDay) {
            this.onlineTimes = []
            this.offlineTimes = []
            return
         }

         let hourList = data.map((item) => {
            let date = new Date(item.heartbeatTime)
            return date.getHours()
         }).sort((a, b) => {
            return a < b
         })

         let isCurrOff = false
         let isLastOff = false

         timeSpanList.map((item, index) => {
            isCurrOff = hourList.indexOf(item) == -1
            if (isCurrOff) {
               if (isLastOff) {
                  this.offlineTimes[this.offlineTimes.length - 1].span += 1
               } else {
                  let lastOnSpan = this.onlineTimes.length
                     ? this.onlineTimes[this.onlineTimes.length - 1].span
                     : 0

                  let offValue = {
                     offset: lastOnSpan,
                     span: 1
                  }
                  this.offlineTimes.push(offValue)
               }
            } else {
               if (isLastOff || index == 0) {
                  let lastOffSpan = this.offlineTimes.length
                     ? this.offlineTimes[this.offlineTimes.length - 1].span
                     : 0
                  let onValue = {
                     offset: lastOffSpan,
                     span: 1
                  }
                  this.onlineTimes.push(onValue)
               } else {
                  this.onlineTimes[this.onlineTimes.length - 1].span += 1
               }
            }
            isLastOff = isCurrOff
         })
      },

      // 处理弹框说明
      handleState(times, index) {
         let startTime = 0
         for (let i = 0; i < index; i++) {
            let time = times[i]
            startTime += time.span + time.offset
         }
         startTime += times[index].offset
         let endTime = startTime + times[index].span - 1
         return startTime + '时-' + endTime + '时'
      },
   }
}
</script>

<style scoped>
.device-container {
   margin: 26px 20px 12px 0px;
   display: flex;
   flex-direction: column;
   justify-content: center;
}

.flex-row {
   display: flex;
   flex-direction: row;
   align-items: center;
}

.el-row:nth-child(2) {
   margin-top: 20px !important;
   height: 18px;
}

.el-row:nth-child(3) {
   height: 18px;
}

.el-row:nth-child(4) {
   margin-top: 10px !important;
}

.device-online {
   height: 10px;
   border-radius: 5px;
   background-color: #15CD85;
   cursor: pointer;
}

.device-offline {
   height: 10px;
   border-radius: 5px;
   background-color: #FF4444;
   cursor: pointer;
}

.device-status {
   width: 50px;
   height: 20px;
}

.device-state {
   font-size: 16px;
   font-weight: 500;
   color: #333333;
}

.device-time {
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
   height: 20px;
   border: 1px solid #EEEEEE;
}
</style>


// WEBPACK FOOTER //
// DeviceStatus.vue?0c1d9e2d